import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { userStageSelector } from 'Store/modules/validations/selectors';
import { stages } from 'Constants/stages';
import { navLinks } from 'Constants/navLinks';
import View from './view';
import { MenuProps } from './types';

const Menu = ({ section }: MenuProps): JSX.Element => {
  const userStage = useSelector(userStageSelector);
  const getStateIndex = (links): number => links.findIndex(item => item.sectionId === userStage);
  const isPathActive = useCallback(sectionId => sectionId === section, [section]);
  const isRouteCompleted = useCallback((links, index) => index < getStateIndex(links), [userStage]);

  const isDisabled = useCallback(
    (links, index) => {
      return index > getStateIndex(links);
    },
    [userStage]
  );
  const filterLinks = useMemo(() => {
    return userStage === stages.SUBMITTED ? [] : navLinks;
  }, [userStage]);

  return (
    <View
      isRouteCompleted={isRouteCompleted}
      isPathActive={isPathActive}
      isDisabled={isDisabled}
      filterLinks={filterLinks}
    />
  );
};

export default Menu;
